import apiCall from "../api/api-call";

const emailService = { sendEmail };

async function sendEmail(
  emailType = "contactUs",
  emailDetails = {
    name: "",
    email: "",
    emailTo: "",
    jobTitle: "",
    subject: "",
    message: "",
  }
) {
  let reqBody = {
    emailType: emailType,
    data: emailDetails,
  };

  //console.log("sendEmail reqBody: ", reqBody);

  return await apiCall.sendEmail(reqBody);
}

export default emailService;
